import React from "react";
import ReactApexChart from "react-apexcharts";
import Card from "components/card";
import { FaThumbsUp, FaThumbsDown, FaMinus } from "react-icons/fa";
import { useFetch } from "hooks/useFetch";
import { urls } from "helpers/urls";
import { Spin } from "antd";

const ChatRatio = () => {
  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Liked", "Disliked", "Neutral"],
    colors: ["#23C552", "#F44336", "#A0AEC0"],
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            show: false,
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  const { data, loading, error } = useFetch({
    url: urls.getFeedback,
  });

  return (
    <Card extra="p-6 h-full" style={{ border: "1px solid #81aae780" }}>
      <h2 className="mb-4 text-2xl font-semibold text-gray-800 dark:text-white">
        Feedback Ratio
      </h2>

      {/* Loading Spinner */}
      {loading ? (
        <div className="loading-container">
          <Spin size="large" tip="Loading feedback data..." />
        </div>
      ) : error ? (
        <div className="error-container">{error}</div>
      ) : (
        // Render Donut Chart and Data if no loading or error
        <div className="flex items-center justify-around">
          <div className="w-1/2">
            <ReactApexChart
              options={options}
              series={[
                data?.data?.like_percentage,
                data?.data?.dislike_percentage,
                data?.data?.neutral_percentage,
              ]}
              type="donut"
            />
          </div>
          <div className="flex w-1/2 flex-col gap-3">
            <div className="flex items-center justify-between rounded-lg bg-green-100 p-3 dark:bg-green-900">
              <div className="flex items-center gap-2">
                <FaThumbsUp className="text-green-500" />
                <span className="font-medium text-green-800 dark:text-green-100">
                  Liked
                </span>
              </div>
              <div className="text-right">
                <p className="font-bold text-green-800 dark:text-green-100">
                  {data?.data?.likes}
                </p>
                <p className="text-sm text-green-600 dark:text-green-300">
                  {data?.data?.like_percentage}%
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between rounded-lg bg-red-100 p-3 dark:bg-red-900">
              <div className="flex items-center gap-2">
                <FaThumbsDown className="text-red-500" />
                <span className="font-medium text-red-800 dark:text-red-100">
                  Disliked
                </span>
              </div>
              <div className="text-right">
                <p className="font-bold text-red-800 dark:text-red-100">
                  {data?.data?.dislikes}
                </p>
                <p className="text-sm text-red-600 dark:text-red-300">
                  {data?.data?.dislike_percentage}%
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between rounded-lg bg-gray-100 p-3 dark:bg-gray-700">
              <div className="flex items-center gap-2">
                <FaMinus className="text-gray-500" />
                <span className="font-medium text-gray-800 dark:text-gray-100">
                  Neutral
                </span>
              </div>
              <div className="text-right">
                <p className="font-bold text-gray-800 dark:text-gray-100">
                  {data?.data?.neutral}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  {data?.data?.neutral_percentage}%
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};

export default ChatRatio;
